import { formatMatterInlineLabelFromData } from './matter-display';

export function matterSearchUrl(text) {
  return `/matters/search/?text=${encodeURIComponent(text ?? '')}`;
}

export function matterFromSearchHit(hit) {
  if (!hit || typeof hit !== 'object') return null;
  const number = hit.name ?? hit.number ?? '';
  return { ...hit, number };
}

export function findExactMatterSearchHit(hits, number) {
  if (!Array.isArray(hits) || number == null || number === '') return null;
  const needle = String(number);
  for (const hit of hits) {
    const mapped = matterFromSearchHit(hit);
    if (!mapped) continue;
    if (String(mapped.number) === needle || String(mapped.altNumber ?? '') === needle) {
      return mapped;
    }
  }
  return null;
}

export function toMatterSelectOption(data, hit) {
  const value = matterFromSearchHit(hit);
  if (!value?.number) return null;
  return {
    label: formatMatterInlineLabelFromData(data, value),
    value,
  };
}
